import React, { useEffect, useState } from 'react'
import Modal from '../../modal/modal.component'
import { useAppContext } from '../../../context/siteMapContext'

const ACCESSIBILITY_POPUP_ID = 'accessibility-popup'

const AccessibilityPopup: React.FC<any> = (props) => {
  const [isOpen, setIsOpen] = useState<boolean>(false)
  const { setAccessibilityShown } = useAppContext();

  const handleClose = () => {
    setIsOpen(false)
    sessionStorage.setItem(ACCESSIBILITY_POPUP_ID, '1');
    setAccessibilityShown(true);
  }

  useEffect(() => {
    const shown = sessionStorage.getItem(ACCESSIBILITY_POPUP_ID)

    if (!shown) {
      setIsOpen(true)

      setTimeout(() => {
        handleClose()
      }, 15000)
    } else {
      setAccessibilityShown(true);
    }
  }, [])

  useEffect(() => {
    if (props.show) {
      setIsOpen(true)

      setTimeout(() => {
        handleClose()
      }, 7000)
    }
  }, [props.show])

  return (
    <Modal isOpen={isOpen} handleClose={handleClose}>
      <div className={`${props.show ? 'text-black' : ''} w-[360px] 2xl:w-[560px] bg-white p-[24px] 2xl:p-[36px] pt-[48px] 2xl:pt-[72px] text-[1.2rem] 2xl:text-[1.5rem]`}>
        <h1>Tisztelt Felhasználónk!</h1>
        <br />

        A weboldal akadálymentes nagy kontrasztú nézetét kiválaszthatja a fejléc vagy a lábléc akadálymentes ikonra kattintással.

        A menüpontok kiválasztását a 𝗧𝗔𝗕 billentyűvel, megnyitásukat az 𝗘𝗡𝗧𝗘𝗥 billentyű megnyomásával tudja elvégezni. Az 𝗘𝗦𝗖 gomb megnyomása esetén vissza tud lépni az előző menübe.

        A Kiemelt Hírek esetében ha zavarja a képek/szövegek mozgása, akkor nyomja meg a 𝗦𝗣𝗔𝗖𝗘 gombot a mozgás leállításához.
        Az akadálymentesítési nyilatkozatot a lábléc “Akadálymentesítési nyilatkozat” gombra kattintással érik el.
      </div>
    </Modal>
  )
}

export default AccessibilityPopup
